import { Piwik } from '@/piwik/types';

import activateCardForm from './sections/activate-card-form';
import applePay from './sections/applePay';
import blockCardForm from './sections/block-card-form';
import cardDetails from './sections/card-details';
import cardOverview from './sections/card-overview';
import closeCreditCardAccountForm from './sections/close-credit-card-account-form';
import creditLimit from './sections/credit-limit';
import documents from './sections/documents';
import googlePay from './sections/google-pay';
import lowerCreditLimit from './sections/lower-credit-limit';
import orderNewCardForm from './sections/order-new-card-form';
import pinChangeDecisionForm from './sections/pin-change-decision-form';
import pinCode from './sections/pin-code';
import regionBlockEcommerce from './sections/region-block-ecommerce';
import reopenCardForm from './sections/reopen-card-form';
import replaceCard from './sections/replace-card';
import transactions from './sections/transactions';
import transfer from './sections/transfer';
import visaCalculator from './sections/visa-calculator';

// PIWIK is a analytics tool that provides reports on the traffic of the application
const piwik: Piwik = {
    cardOverview,
    closeCreditCardAccountForm,
    visaCalculator,
    cardDetails,
    reopenCardForm,
    documents,
    blockCardForm,
    creditLimit,
    lowerCreditLimit,
    orderNewCardForm,
    pinChangeDecisionForm,
    pinCode,
    regionBlockEcommerce,
    replaceCard,
    transactions,
    transfer,
    googlePay,
    activateCardForm,
    applePay,
};

export default piwik;
